import React, { useEffect, useRef } from "react";
import styles from "./style.module.scss";
import MeetUsWrapper from "Components/MeetUsWrapper";
import PhasePlaceholder from "../../../Utils/Assets/Images/Phase2-Placeholder.png";

const StakingGuide = () => {
    const scrollRef = useRef(null);
    const thumbRef = useRef(null);

    useEffect(() => {
        const box = scrollRef.current;
        const thumb = thumbRef.current;

        if (!box || !thumb) return;

        const handleScroll = () => {
            const isMobile = window.innerWidth <= 768;

            if (isMobile) {
                const scrollLeft = box.scrollLeft;
                const scrollWidth = box.scrollWidth - box.clientWidth;
                const trackWidth = box.clientWidth - thumb.offsetWidth;

                const ratio = scrollLeft / scrollWidth;
                thumb.style.transform = `translateX(${trackWidth * ratio}px)`;
            } else {
                const scrollTop = box.scrollTop;
                const scrollHeight = box.scrollHeight - box.clientHeight;
                const trackHeight = box.clientHeight - thumb.offsetHeight;

                const ratio = scrollTop / scrollHeight;
                thumb.style.transform = `translateY(${trackHeight * ratio}px)`;
            }
        };

        box.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleScroll);

        return () => {
            box.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleScroll);
        };
    }, []);

    return (
        <div className={styles.StakingGuideContainer}>
            <MeetUsWrapper>
                <section className={styles.StakingGuideSection}>
                    <div
                        className={styles.StakingGuideRightCard}
                        data-aos="fade-right"
                        data-aos-duration="800"
                        data-aos-once="false"
                    >
                        <div className={styles.StakingGuideCardImage}>
                            <img
                                src={PhasePlaceholder}
                                alt="Phase2-Placeholder"
                            />
                        </div>
                    </div>

                    <div className={styles.StakingGuideLeftCard}>
                        <p
                            className={styles.StakingGuideTitle}
                            data-aos="fade-up"
                            data-aos-duration="800"
                            data-aos-once="false"
                        >
                            How to Sign Up & Start <br />
                            Staking Coins
                        </p>

                        <div
                            className={styles.StakingGuideScrollWrapper}
                            data-aos="fade-up"
                            data-aos-duration="800"
                            data-aos-once="false"
                        >
                            <div
                                className={styles.StakingGuideScroll}
                                ref={scrollRef}
                            >
                                <div
                                    className={styles.StakingGuideScrollContent}
                                >
                                    <p
                                        className={
                                            styles.StakingGuideScrollContentTitle
                                        }
                                    >
                                        Sign Up & Get Your MVR Wallet Instantly
                                    </p>
                                    <p
                                        className={
                                            styles.StakingGuideScrollContentDescription
                                        }
                                    >
                                        Explore products, services, or premium
                                        features like virtual rooms. Click on
                                        your desired option to view details.
                                    </p>
                                </div>
                                <div
                                    className={styles.StakingGuideScrollContent}
                                >
                                    <p
                                        className={
                                            styles.StakingGuideScrollContentTitle
                                        }
                                    >
                                        Go to Your Staking Dashboard
                                    </p>
                                    <p
                                        className={
                                            styles.StakingGuideScrollContentDescription
                                        }
                                    >
                                        For virtual features, click “Redeem
                                        Now.” For products or services, add them
                                        to your cart and proceed to checkout.
                                    </p>
                                </div>
                                <div
                                    className={styles.StakingGuideScrollContent}
                                >
                                    <p
                                        className={
                                            styles.StakingGuideScrollContentTitle
                                        }
                                    >
                                        Choose Your Staking Plan & Start Earning
                                    </p>
                                    <p
                                        className={
                                            styles.StakingGuideScrollContentDescription
                                        }
                                    >
                                        Review your selection, confirm the
                                        purchase, and start enjoying your
                                        unlocked item, feature, or experience!
                                    </p>
                                </div>
                            </div>

                            <div className={styles.StakingGuideScrollIndicator}>
                                <span
                                    ref={thumbRef}
                                    className={styles.StakingGuideScrollThumb}
                                ></span>
                            </div>
                        </div>
                    </div>
                </section>
            </MeetUsWrapper>
        </div>
    );
};

export default StakingGuide;
